//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import UserInfoModule from "../content/home/user-infocard";
import UserTasksModule from "../content/home/user-tasks";

import { UserForm } from "../services/srvc-utilities";

export default function HomeBusiness() {

  return (
  <>
    <ContentFormatXC 
      head='Home'
      link={`/${UserForm()}/home`}
      form= 'wide'
      data= {
        <>
          <WebbDividerSmall />
          <UserInfoModule />

          <UserTasksModule />


        </>
      } 
    />
  </>
  )
}